<template>
  <div>
   <div class="row">
      <div class="col-md-2">
        <div class="form-group">
          <label class="form-label-control mb-0">Total Conductores</label>
          <p v-if="this.totalRows > 0">{{ this.totalRows}}</p>
        </div>
      </div>
      <div class="col-md-2">
        <div class="form-group">
          <label class="form-label-control mb-0">Total Emergencias</label>
          <p v-if="this.totalEmergencyDrivers > 0">{{ this.totalEmergencyDrivers}}</p>
        </div>
      </div>
      <div class="col-md-2">
        <div class="form-group">
          <label class="form-label-control mb-0">Total Activos </label>
          <p v-if="this.totalActiveDrivers > 0">{{ this.totalActiveDrivers}}</p>
        </div>
      </div>
      <div class="col-md-2">
        <div class="form-group">
          <label class="form-label-control mb-0">Total Inactivos</label>
          <p v-if="this.totalInactiveDrivers > 0">{{ this.totalInactiveDrivers}}</p>
        </div>
      </div>
      <div class="col-md-2">
        <div class="form-group">
          <label class="form-label-control mb-0">Total Viajes </label>
          <p v-if="this.totalOnTripDrivers > 0">{{ this.totalOnTripDrivers}}</p>
        </div>
      </div>
    </div>
    <div class="row">
      <span/>
    </div>
    <GoogleMapLoader
      :mapConfig="mapConfig"
      :apiKey="mapKey">
      <template slot-scope="{google, map}" ref="map">
        <FirebaseGoogleMapMarker
          :google="google"
          :map="map"
          @updatedInfo="displayInfo"
        />
      </template>
    </GoogleMapLoader>
  </div>
</template>
<script>
import GoogleMapLoader from '../map/GoogleMapLoader'
import FirebaseGoogleMapMarker from '../map/FirebaseGoogleMapMarker'
import { mapSettings } from '../../../constants/mapSettings'
import config from '../../../../environment.json'
export default {
  name: 'FirebaseTravelMap',
  components: {
    GoogleMapLoader,
    FirebaseGoogleMapMarker,
  },
  computed: {
    mapConfig () {
      return {
        ...mapSettings,
        center: this.mapCenter,
      }
    },
    mapCenter () {
      return { lat: 20.1186645, lng: -98.7491321 }
    },
  },
  data() {
    return {
      totalEmergencyDrivers: 0,
      totalActiveDrivers: 0,
      totalInactiveDrivers: 0,
      totalOnTripDrivers: 0,
      totalRows: 0,
      mapKey: config[process.env.NODE_ENV].mapKey,
    }
  },
  methods: {
    displayInfo (value) {
      this.totalEmergencyDrivers = value.totalEmergencyDrivers
      this.totalActiveDrivers = value.totalActiveDrivers
      this.totalInactiveDrivers = value.totalInactiveDrivers
      this.totalOnTripDrivers = value.totalOnTripDrivers
      this.totalRows = value.totalRows

      console.log(value) // someValue
    },
  },
}
</script>
